import "./lib/polyfills"; // first: engine API gaps (Firefox 68 on the Elo shell)
import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/global.css";
import { hydrateRuntimeConfig } from "./config/runtime";
import { installStoreTimezone } from "./lib/storeTime";
import { installCrashReporting, showBootFailure } from "./lib/crashReport";
import { registerWebServiceWorker, requestPersistentStorage, startBuildWatch } from "./pwa";

// KDS entry: the same app, KDS variant — only the orders board and settings
// are routed (and loaded), so a low-RAM kiosk never pulls the POS screens.
async function boot() {
  installCrashReporting();
  await hydrateRuntimeConfig();
  // Venue time on every screen, even a kiosk stuck on the wrong timezone.
  try { installStoreTimezone(); } catch {}
  // The offline shell is a nicety; a browser that can't do it must still
  // show the board (an old engine threw here and the page stayed blank).
  try { registerWebServiceWorker(); } catch {}
  try { startBuildWatch(); } catch {}
  try { void requestPersistentStorage(); } catch {}
  // Kiosks whose browser keeps nothing: get this device's settings back from the hub.
  try { await (await import("./services/hub")).restoreDeviceBackupIfEmpty(); } catch {}
  const { default: App } = await import("./App");
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App variant="kds" />
    </React.StrictMode>
  );
}
void boot().catch((e) => showBootFailure(e));
